import React, {Component} from 'react';
import SideBar from './sidebar/SideBar';
import Footer from './components/Footer';
import Nav from './Header/Nav';
import backend from '../assets/images/backend.jpg';
import phpsvg from '../assets/images/php.svg';
import training7 from '../assets/images/training7.jpg';
import DevelopRequest from './components/DevelopRequest';
import Subscribe from './components/Subscribe';

class BackendBundle extends Component{
    render(){
        return(
            <div id="App">
            <SideBar />
                <Nav />
            <header class="showcase" style={{height:'80vh', marginTop:'5vh', backgroundImage: `url(${training7})`}}>
			<div className="showcase-content">
                <div></div>
                <div>
				<h1>Be in <span className="alt-col" style={{color:'rgba(226, 155, 24, 0.945)'}}> Demand.</span></h1>
                <p>"What separates design from art is that design is meant to be ... functional."</p>
                <p>
                &mdash; Cameron Moll.
                </p>
                </div>
			</div>
		</header>
        <div className="about">
            <div style={{backgroundImage: `url(${backend})`, backgroundClip:'border-box', backgroundPosition:'center', backgroundSize:'cover'}}></div>

            <div>
            <h3 className="path">Backend Web Developer Bundle</h3>
            <img src={phpsvg} alt="Data science training in abuja" />
            <p> 
                Backend web development is a combination of a database and a software written in a server-side language which runs
                on web servers, cloud servers or a combination of both.
            </p>
            <p> 
                This training will teach you how to build a dynamic, database-driven website.
            </p>

            <h3>courses</h3>
            <p>
                HTML5, CSS3, PHP 7, MySQL.
            </p>

            <h3>call anytime</h3>
            <p>07063509602, 07084894979</p>
            <p>info@codeflarelimited.com</p>

            <h3>visit us</h3>
            <p>Suite C3-19 Central Market Plaza, Beside Sledge Resort, Off Byazhin Roundabout, Kubwa, Abuja.</p>
            </div>
        </div>
        <DevelopRequest />
        <Subscribe />
        <Footer />
            </div>
        )
    }
}
export default BackendBundle;